var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{staticClass:"button-field"},[_c('el-button',{attrs:{"native-type":"submit","disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }